import styles from "./logdetails.module.css";
import Loader from "../../../components/Loader";
import Footer from "../../../components/Footer";
import { useAuth0 } from "@auth0/auth0-react";
import { FormControl, InputLabel, MenuItem, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { ArrowLeft, Home, Search } from "react-feather";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { TableLoaderSmall } from "../../../components/LoaderC";
import { useState, useEffect } from "react";
import axios from 'axios';
import dayjs from "dayjs";
import withCustomAuthenticationRequired from "../../../auth/withCustomAuthenticationRequired";

const LogDetails = ({ history, match }) => {
    const { getAccessTokenSilently } = useAuth0();
    const { id } = match.params;
    const [contentLoading, setContentLoading] = useState(true);
    const [emailLogDet, setEmailLogDet] = useState(null);
    const [filterEmails, setfilterEmails] = useState([]);
    const [filterData, setFilterData] = useState({ searchKey: "", type: "" });

    useEffect(() => {
        const getCampaignList = async () => {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

            axios(process.env.REACT_APP_USER_API_URL + "v1/campaign/email-campaign-logs/" + id, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }).then((response) => {
                setContentLoading(false);
                setEmailLogDet(response.data.data);
            }).catch(() => {
                setContentLoading(false);
            });
        }
        if (id)
            getCampaignList();
    }, [getAccessTokenSilently, id]);

    useEffect(() => {
        let filteredDataTemp = emailLogDet?.emails;

        if (filterData.searchKey !== "") {
            let inputVal = filterData.searchKey;
            inputVal = inputVal.toLowerCase();
            filteredDataTemp = filteredDataTemp.filter((item) => {
                return item?.email.toLowerCase().includes(inputVal);
            });
        }

        if (filterData.type !== "" && filterData.type !== "all") {
            if (filterData.type === "sent") {
                filteredDataTemp = filteredDataTemp.filter((item) => item?.is_delivery === 1);
            }
            if (filterData.type === "open") {
                filteredDataTemp = filteredDataTemp.filter((item) => item?.is_open === 1);
            }
            if (filterData.type === "click") {
                filteredDataTemp = filteredDataTemp.filter((item) => item?.is_click === 1);
            }
            if (filterData.type === "bounce") {
                filteredDataTemp = filteredDataTemp.filter((item) => item?.is_bounce === 1);
            }
        }

        setfilterEmails(filteredDataTemp);
    }, [emailLogDet?.emails, filterData]);

    return (<>
        <Helmet title={"Email analytics: " + emailLogDet?.subject} />

        <div className={`${styles.mainCard}`}>
            <div className={`${styles.SMProCusRow}`}>
                <div className={`${styles.BreadcrumbHeadSec}`}>
                    <nav aria-label="breadcrumb">
                        <ol className={`${styles.breadcrumb}`}>
                            <li className={`${styles.breadcrumbItem}`}><span><Home /></span>Email Analytics</li>
                            <li className={`${styles.breadcrumbItem} ${styles.active}`}>{emailLogDet?.subject}</li>
                        </ol>
                    </nav>
                    <div className={`${styles.PageTitleSec}`}>
                        <div>
                            <Link to={`/communication/analytics`} className={`${styles.BackArrow}`}>
                                <ArrowLeft />
                            </Link>
                            <Typography display="inline" className={`${styles.pageTitle}`}>{emailLogDet?.subject}</Typography>
                        </div>
                    </div>
                </div>

                <div className={`${styles.RentRollDetailsSec}`}>
                    {contentLoading && <div className="Loader TableLoader"><TableLoaderSmall /></div>}

                    {!contentLoading && <div className={`${styles.ButtonArea}`}>
                        <div className={`${styles.ButtonAreaUnder}`}>
                            <div className={`${styles.FilterSearchSec}`}>
                                <div className={`${styles.NotesSearchMain}`}>
                                    <Search />
                                    <input type="text" placeholder="Search" className={`${styles.searchInput}`} onChange={(e) => {
                                        setFilterData(prev => {
                                            return { ...prev, searchKey: e.target.value }
                                        });
                                    }} />
                                </div>
                                <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width220} CusSelectFilter Filter`}>
                                    <FormControl fullWidth>
                                        <InputLabel id="demo-simple-select-label">Filter by recipients status</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            label="Filter by recipients status"
                                            onChange={(e) => {
                                                setFilterData(prev => {
                                                    return { ...prev, type: e.target.value }
                                                });
                                            }}
                                        >
                                            <MenuItem value="all">All</MenuItem>
                                            <MenuItem value="sent">Sent</MenuItem>
                                            <MenuItem value="open">Open</MenuItem>
                                            <MenuItem value="click">Click</MenuItem>
                                            <MenuItem value="bounce">Bounced</MenuItem>
                                        </Select>
                                    </FormControl>
                                </div>
                            </div>

                            <div className={`${styles.EmailDetailsTopSec}`}>
                                <div className={`${styles.DetailsTopHeading}`}>Recipient activity summary</div>
                                <div className={`${styles.DetailsTopCard}`}>
                                    <p className={`${styles.Title}`}>Total sends</p>
                                    <p className={`${styles.SubTitle}`}>{emailLogDet?.number_of_receipient}</p>
                                </div>
                                <div className={`${styles.DetailsTopCard}`}>
                                    <p className={`${styles.Title}`}>Delivery rate</p>
                                    <p className={`${styles.SubTitle}`}>{emailLogDet?.delivery_percentage}%</p>
                                </div>
                                <div className={`${styles.DetailsTopCard}`}>
                                    <p className={`${styles.Title}`}>Open rate</p>
                                    <p className={`${styles.SubTitle}`}>{emailLogDet?.open_percentage}%</p>
                                </div>
                                <div className={`${styles.DetailsTopCard}`}>
                                    <p className={`${styles.Title}`}>Click rate</p>
                                    <p className={`${styles.SubTitle}`}>{emailLogDet?.click_percentage}%</p>
                                </div>
                            </div>

                            <div className={`${styles.ListCardDivMainSec}`}>
                                <div className={`${styles.ListCardDivSec}`}>
                                    {filterEmails?.map(item => {
                                        return (<div className={`${styles.CardDivList}`}>
                                            <div className={`${styles.FirstSec}`}>
                                                <div>
                                                    <p className={`${styles.Name}`}>{item?.email}</p>
                                                    <p className={`${styles.Name}`}>{dayjs(item?.created_at).format('ddd, MMM D, hh.mm A')}</p>
                                                </div>
                                            </div>
                                            <div className={`${styles.SecondSec}`}>
                                                <p className={`${styles.Name}`}>Clicks: <span>{item?.no_of_click}</span></p>
                                                <p className={`${styles.Name}`}>Open: <span>{item?.no_of_open}</span></p>
                                            </div>
                                            <div className={`${styles.ThirdSec}`}>
                                                {item?.is_bounce === 1 && item?.is_delivery === 0 && <span className={`${styles.StatusBadge} ${styles.Bounced}`}>Bounced</span>}
                                                {item?.is_delivery === 1 && item?.is_open === 0 && item?.is_click === 0 && <span className={`${styles.StatusBadge} ${styles.Sent}`}>Delivered</span>}
                                                {item?.is_open === 1 && item?.is_click === 0 && <span className={`${styles.StatusBadge} ${styles.Open}`}>Opened</span>}
                                                {item?.is_click === 1 && <span className={`${styles.StatusBadge} ${styles.Click}`}>Clicked</span>}
                                            </div>
                                        </div>)
                                    })}
                                </div>
                            </div>

                            <div className={`${styles.StatusTable}`}>
                                <TableContainer className={`${styles.TableDiv} CustomTableDiv`}>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell className={`${styles.TableHead}`} style={{ width: 300 }}>Email</TableCell>
                                                <TableCell className={`${styles.TableHead}`} style={{ width: 150 }}>Status</TableCell>
                                                <TableCell className={`${styles.TableHead}`} style={{ width: 150 }}>Clicks</TableCell>
                                                <TableCell className={`${styles.TableHead}`} style={{ width: 150 }}>Open</TableCell>
                                                <TableCell className={`${styles.TableHead}`} style={{ width: 250 }}>Time</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {filterEmails?.map(item => {
                                                return (<TableRow>
                                                    <TableCell className={`${styles.TableBodyText}`}>{item?.email}</TableCell>
                                                    <TableCell className={`${styles.TableBodyText}`} >
                                                        {item?.is_bounce === 1 && <span className={`${styles.StatusBadge} ${styles.Bounced}`}>Bounced</span>}
                                                        {item?.is_delivery === 1 && item?.is_open === 0 && item?.is_click === 0 && <span className={`${styles.StatusBadge} ${styles.Sent}`}>Delivered</span>}
                                                        {item?.is_open === 1 && item?.is_click === 0 && <span className={`${styles.StatusBadge} ${styles.Open}`}>Opened</span>}
                                                        {item?.is_click === 1 && <span className={`${styles.StatusBadge} ${styles.Click}`}>Clicked</span>}
                                                    </TableCell>
                                                    <TableCell className={`${styles.TableBodyText}`}>{item?.no_of_click}</TableCell>
                                                    <TableCell className={`${styles.TableBodyText}`}>{item?.no_of_open}</TableCell>
                                                    <TableCell className={`${styles.TableBodyText}`}>{dayjs(item?.created_at).format('ddd, MMM D, hh.mm A')}</TableCell>
                                                </TableRow>)
                                            })}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div>

                        </div>
                    </div>}

                </div>
            </div>
        </div>


        <Footer />
    </>)
}

export default withCustomAuthenticationRequired(LogDetails, {
    onRedirecting: () => <Loader />,
});